const Condition = require('../condition')
const Rule = require('../rule')
const FluxMessage = require('./message')
const FluxStories = require('./stories')
const FluxKB = require('./kb')
const FluxSurvey = require('./survey')
const FluxStatistics = require('./statistics')
const BinaryParser = require('mongo-binary-parser')
const FluxForm = require('./form')

class Flux {
  constructor(flux) {
    this.id = flux.id || flux._id
    this._id = this.id
    this.name = flux.name
    this.enabled = flux.enabled
    this.order = flux.order
    this.allConditions = flux.allConditions
    this.formRequired = typeof flux.formRequired === 'undefined' ? true : flux.formRequired
    /**
     * @type {FluxStatistics}
     */
    this.statistics = new FluxStatistics(flux.statistics)
    /**
     * @type {Condition[]}
     */
    this.conditions = flux.conditions.map(c => new Condition(c))
    /**
     * @type {Rule[]}
     */
    this.rules = flux.rules.map(r => new Rule(r))
    /**
     * @type {FluxKB}
     */
    this.kb = new FluxKB(flux.kb)
    /**
     * @type {FluxMessage}
     */
    this.message = new FluxMessage(flux.message)
    /**
     * @type {FluxStories}
     */
    this.stories = new FluxStories(flux.stories)
    /**
     * @type {FluxSurvey}
     */
    this.survey = new FluxSurvey(flux.survey)

    if (flux.formId) {
      this.formId = BinaryParser.BinaryToGUID(flux.formId)
    }
    
    if (flux.form) {
      this.form = new FluxForm(flux.form)
    }

    /**
     * @type {string}
     */
    this.botId = flux.botId || null
  }

  valid(session) {
    if (this.enabled) {
      const method = this.allConditions ? 'every' : 'some'
      return this.conditions.length ? this.conditions[method](condition => condition.valid(session)) : true
    } else {
      return false
    }
  }
}

module.exports = Flux
